/**
 * 定时计划类型
 */
export enum ScheduleTypeE {
    /**
     * 块CDP
     */
    Block = 'block',
    /**
     * 文件CDP
     */
    File = 'file',
}
